<div class="data-section">
  <div class="data-section-heading">&nbsp;</div>
  <div class="data-section-content flex-column-container gap-10">
    <div class="flex-row-container gap-40">
      <div class="custom-flex-30">
        <strong>{{ 'age' | translate }}</strong>
      </div>
      <div class="custom-flex-70">
        <p>
          @if (patientAge) {
          {{ patientAge }}
          } @else {
          {{ 'surgical_qa_panel.patient_age_is_unknown' | translate }}
          }
        </p>
      </div>
    </div>

    <div class="flex-row-container gap-40">
      <div class="custom-flex-30">
        <strong>{{ 'operations' | translate }}</strong>
      </div>
      <div class="custom-flex-70 flex-column-container">
        @if (operationDescription.surgicalInterventionTypes) { @for (type of operationDescription.surgicalInterventionTypes; track type) {
        <p>
          {{ type | translate }}
        </p>
        } } @else {
        <p>
          {{ 'surgical_qa_panel.unknown_intervention_type' | translate }}
        </p>
        }
      </div>
    </div>

    <div class="flex-row-container gap-40">
      <div class="custom-flex-30">
        <strong>{{ 'surgical_qa_panel.type_of_repairs' | translate }}</strong>
      </div>
      <div class="flex-column-container custom-flex-70">
        @if (operationDescription.repairTypes) { @for (repairType of operationDescription.repairTypes; track repairType) {
        <p>
          {{ repairType | translate }}
        </p>
        } } @else {
        <p>
          {{ 'surgical_qa_panel.unknown_types_of_repairs' | translate }}
        </p>
        }
      </div>
    </div>

    @if (operationDescription.comment) {
    <div class="flex-row-container gap-40 custom-flex-70">
      <strong>{{ 'surgical_qa_panel.comments' | translate }}</strong>
      <p>
        {{ operationDescription.comment }}
      </p>
    </div>
    }
  </div>
</div>
